import styled, { css } from 'styled-components';

import { tokens } from '../../../../tokens';

interface DividerWrapperProps {
    $partial?: boolean;
}

const dividerHeight = 1;

const dividerBase = css`
    content: '';
    display: block;
    height: ${dividerHeight}px;
    background-color: ${({ theme }) => theme.colors.carbon};
`;

export const DividerWrapper = styled.div<DividerWrapperProps>`
    --yat_sheet-divider-spacing: ${tokens.spacing.tight}px;
    display: grid;
    grid-template-columns: ${({ $partial }) => ($partial ? '1fr auto 1fr' : '1fr')};
    gap: var(--yat_sheet-divider-spacing);
    align-content: center;
    align-items: center;
    margin-top: var(--yat_sheet-divider-spacing);
    margin-bottom: var(--yat_sheet-divider-spacing);
    min-height: ${dividerHeight}px;
    text-align: center;

    &:first-child {
        margin-top: 0;
    }

    &::before,
    &::after {
        ${({ $partial }) =>
            $partial &&
            css`
                min-width: ${tokens.spacing.loose}px;
            `};
    }

    &::before {
        ${dividerBase};
    }

    &::after {
        ${({ $partial }) => $partial && dividerBase};
    }
`;

export const ChildrenWrapper = styled.div``;
